/**
 * 财务管理相关常量定义
 */

/**
 * 费用类型枚举
 */
export enum ExpenseType {
  CONSULTATION_FEE = 'CONSULTATION_FEE',
  LAWYER_FEE = 'LAWYER_FEE',
  CONSULTANT_FEE = 'CONSULTANT_FEE',
  SERVICE_FEE = 'SERVICE_FEE',
  TRAVEL_FEE = 'TRAVEL_FEE',
  OTHER = 'OTHER',
}

/**
 * 费用类型映射（用于显示）
 */
export const EXPENSE_TYPE_MAP: Record<string, string> = {
  CONSULTATION_FEE: '咨询费',
  LAWYER_FEE: '律师费',
  CONSULTANT_FEE: '顾问费',
  SERVICE_FEE: '服务费',
  TRAVEL_FEE: '差旅费',
  OTHER: '其他',
};

/**
 * 费用类型选项（用于下拉选择）
 */
export const EXPENSE_TYPE_OPTIONS = [
  { label: '咨询费', value: 'CONSULTATION_FEE' },
  { label: '律师费', value: 'LAWYER_FEE' },
  { label: '顾问费', value: 'CONSULTANT_FEE' },
  { label: '服务费', value: 'SERVICE_FEE' },
  { label: '差旅费', value: 'TRAVEL_FEE' },
  { label: '其他', value: 'OTHER' },
];

/**
 * 款项性质枚举
 */
export enum PaymentNature {
  RECEIVED = 'RECEIVED',
  RECEIVABLE = 'RECEIVABLE',
  REFUND = 'REFUND',
}

/**
 * 款项性质映射（用于显示）
 */
export const PAYMENT_NATURE_MAP: Record<string, string> = {
  RECEIVED: '已收款',
  RECEIVABLE: '应收款',
  REFUND: '退款',
};

/**
 * 款项性质颜色映射（用于Tag组件）
 */
export const PAYMENT_NATURE_COLOR: Record<string, string> = {
  RECEIVED: 'success',
  RECEIVABLE: 'warning',
  REFUND: 'error',
};

/**
 * 款项性质选项（用于单选）
 */
export const PAYMENT_NATURE_OPTIONS = [
  { label: '已收款', value: 'RECEIVED' },
  { label: '应收款', value: 'RECEIVABLE' },
  { label: '退款', value: 'REFUND' },
];

/**
 * 文件上传限制
 */
export const FILE_UPLOAD_CONFIG = {
  maxSize: 20 * 1024 * 1024, // 20MB
  maxCount: 5,
  accept: '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png',
  acceptedTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/png',
  ],
};
